import React from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const Cell = ({
  children,
  autoWrap,
  fill,
  className,
  ...rest
}) => {
  const classes = useStyle({ autoWrap, fill });

  return (
    <div
      className={cx(
        classes.cell,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

Cell.propTypes = {
  /* should this element wrapped when there is no space left? */
  autoWrap: PropTypes.bool,
  /* fill empty space at end and start of content */
  fill: PropTypes.bool,
};

Cell.defaultProps = {
  autoWrap: false,
  fill: true,
};

export default Cell;
